module.exports = __webpack_public_path__ + "static/img/4.a0deefa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/articles/200204/4.jpg
// module id = WaHa
// module chunks = 1